import React, { useState } from 'react';
import { Modal, Box, Typography, Button, IconButton } from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import CheckIcon from '@mui/icons-material/Check';
import { ACTION_BLUE } from '../../../theme/theme';

interface TestAppModalProps {
  open: boolean;
  onClose: () => void;
  appId: string;
}

const TestAppModal: React.FC<TestAppModalProps> = ({
  open,
  onClose,
  appId,
}) => {
  const deepLink = `sibche://applications/${appId}`;
  const [isCopied, setIsCopied] = useState(false);

  const handleCopyLink = () => {
    navigator.clipboard.writeText(deepLink);
    setIsCopied(true);

    // بعد از 2 ثانیه آیکون را به حالت اولیه برگردان
    setTimeout(() => {
      setIsCopied(false);
    }, 2000);
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="test-app-modal"
      aria-describedby="modal-for-testing-app"
    >
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: { xs: '90%', sm: '80%', md: '500px' },
          maxWidth: '500px',
          bgcolor: 'background.paper',
          borderRadius: 2,
          boxShadow: 24,
          p: '16px',
          direction: 'rtl',
        }}
      >
        <Typography
          variant="h6"
          sx={{
            fontFamily: 'IRANYekanXFaNum',
            fontWeight: 700,
            fontSize: 18,
            color: '#25282E',
            textAlign: 'center',
            marginBottom: 3,
          }}
        >
          تست اپلیکیشن
        </Typography>

        <Typography
          sx={{
            fontFamily: 'IRANYekanXFaNum',
            fontSize: 14,
            color: '#60646E',
            textAlign: 'center',
            lineHeight: '24px',
            marginBottom: 3,
          }}
        >
          درصورتی که اپلیکیشن سیبچه برروی گوشی خود دارید می‌توانید با رفتن به
          این لینک اپ خود را نصب کنید و قبل از انتشار مشکلات آن را ارزیابی کنید
        </Typography>

        <Box
          sx={{
            backgroundColor: '#F8F9FA',
            border: '1px solid #E9ECEF',
            borderRadius: 2,
            padding: 2,
            marginBottom: 3,
            direction: 'ltr',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: 2,
          }}
        >
          <Typography
            sx={{
              fontFamily: 'IRANYekanXFaNum',
              fontSize: 14,
              color: '#1E88E5',
              fontWeight: 500,
              wordBreak: 'break-all',
              flex: 1,
              textAlign: 'left',
              userSelect: 'text',
              cursor: 'text',
            }}
          >
            {deepLink}
          </Typography>
          <IconButton
            onClick={handleCopyLink}
            size="small"
            sx={{
              color: isCopied ? '#4CAF50' : '#1E88E5',
              backgroundColor: isCopied ? '#E8F5E8' : '#E3F2FD',
              borderRadius: 1,
              padding: 1,
              transition: 'all 0.3s ease',
              '&:hover': {
                backgroundColor: isCopied ? '#C8E6C9' : '#BBDEFB',
                color: isCopied ? '#2E7D32' : '#1565C0',
              },
            }}
          >
            {isCopied ? (
              <CheckIcon fontSize="small" />
            ) : (
              <ContentCopyIcon fontSize="small" />
            )}
          </IconButton>
        </Box>

        <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
          <Button
            variant="contained"
            onClick={onClose}
            sx={{
              backgroundColor: ACTION_BLUE,
              color: '#FFFFFF',
              fontFamily: 'IRANYekanXFaNum',
              fontSize: 14,
              fontWeight: 500,
              textTransform: 'none',
              borderRadius: 2,
              padding: '8px 24px',
              '&:hover': {
                backgroundColor: '#1565C0',
              },
            }}
          >
            بستن
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default TestAppModal;
